import { mildGray } from './variables'

export const fieldLabel = `
  label {
    margin-left: 8px;
    font-size: 14px;
    color: ${mildGray};
    margin-bottom: 4px;
  }
`

export const cellImageStyle = image => (
  {
    minHeight: '42px',
    width: '100%',
    backgroundImage: `url('${image}')`,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    border: '4px solid white',
    boxSizing: 'border-box',
  }
)
